import api from './api';

export type ProtocolType = 'POCR' | 'POKR';

export interface CreateProtocolPayload {
  project_id: string;
  subcontractor_id: number | string;
  type: ProtocolType;
  protocol_date: string; // YYYY-MM-DD
  work_from_date?: string | null;
  work_to_date?: string | null;
  contract_value: number;
  progress_percent: number;
  value_since_start: number;
  value_in_period: number;
  remaining_to_invoice: number;
  gw_person1?: string | null;
  gw_person2?: string | null;
  subcontractor_person1?: string | null;
  subcontractor_person2?: string | null;
  defects_notes?: string | null;
  summary_decision: 'bez_uwag' | 'z_uwagami' | 'nie_odbiera_do_usuniecia' | 'nie_odbiera_nie_do_usuniecia';
}

export interface ProtocolItem {
  id: string | number;
  type: ProtocolType;
  protocol_number?: string;
  generated_pdf_url?: string;
  generated_google_doc_url?: string;
  gmail_message_id?: string | null;
  gmail_draft_id?: string | null;
}

const protocolService = {
  createProtocol: async (payload: CreateProtocolPayload, googleAccessToken?: string) => {
    const res = await api.post('/protocols', payload, {
      headers: googleAccessToken ? { 'x-google-access-token': googleAccessToken } : undefined,
    });
    return res.data?.data ?? res.data;
  },
  getByProject: async (projectId: string) => {
    const res = await api.get(`/protocols/project/${projectId}`);
    return res.data?.data ?? res.data;
  },
  delete: async (id: number | string) => {
    const res = await api.delete(`/protocols/${id}`);
    return res.data?.success ?? true;
  },
  sendEmail: async (id: number | string, payload: { to: string; subject: string; body: string }) => {
    const res = await api.post(`/protocols/${id}/send-email`, payload);
    return res.data?.data ?? res.data;
  },
  createDraft: async (id: number | string, payload: { to: string; subject: string; body: string }) => {
    const res = await api.post(`/protocols/${id}/create-draft`, payload);
    return res.data?.data ?? res.data;
  }
};

export default protocolService;


